import React from "react"

const BackgroundShape = props => {
	return (
		<div
			className={`shape-container ${props.style.shape} ${props.style.color}`}
		>
		</div>
	)
}

export default BackgroundShape
